<template>
  <div class="invItems">
    <editCubeDate title="發票開立品項列表" :col="true" :w="'430px'" :defaultValue="info.InvoiceItemsList" @save="$emit('update', { InvoiceItemsList: $event })"/>
    <editCubeDate title="招待項目" :w="'200px'" :defaultValue="ServeReasons||[]" @save="updateSelection($event)"/>
    <editCubeDate title="專案" :w="'200px'" :defaultValue="info.restProject" @save="$emit('update', { restProject: $event })"/>
  </div>
</template>

<script>
import { getapi, postapi } from '../../store/fetch'
import editCubeDate from '../../components/editCube3info.vue'
export default {
  props: ['info'],
  components: {
    editCubeDate
  },
  data () {
    return {
      ServeReasons: []
    }
  },
  async mounted () {
    this.ServeReasons = await getapi('selections/ServeReasons')
  },
  methods: {
    async updateSelection (ev) {
      this.ServeReasons = await postapi('selections/ServeReasons', { key: 'options', data: ev })
    }
  }
}
</script>

<style lang="scss" scoped>
.invItems {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-start;
  gap: 50px;
  height: calc(100vh - 90px);
  &>div{
    padding: 25px 53px 25px 52px;
    border-right: 1px solid #CACACA;
    height: 100%;

  }
}
</style>
